import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Table, Row, Col, Container } from 'react-bootstrap';
import s from './ItemList.css';
import rs from '../../../restaurantCommon.css';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
//local
import messages from '../../../../locale/messages';
import CustomPagination from '../../../CustomPagination/CustomPagination';
import Link from '../../../Link/Link';
import { Button, FormControl, ButtonToolbar } from 'react-bootstrap';
import { connect } from 'react-redux';
import Loader from '../../../Common/Loader';

//Images
import EditIcon from '../../../../../public/RestaurantIcon/edit.png';
import TrashIcon from '../../../../../public/RestaurantIcon/dlty.png';
import VegIcon from '../../../../../public/RestaurantIcon/veg.png';
import NonVegIcon from '../../../../../public/RestaurantIcon/non-veg.png';

import updateItemStatus from '../../../../actions/shop/menu/updateItemStatus';
import deleteItem from '../../../../actions/shop/menu/deleteItem';
import editItem from '../../../../actions/shop/menu/editItem';

import updateSubMenuStatus from '../../../../actions/shop/menu/updateSubMenuStatus';
import deleteSubMenu from '../../../../actions/shop/menu/deleteSubMenu';
import editSubMenu from '../../../../actions/shop/menu/editSubMenu';

import { openSubMenuModal, openModal, closeModal } from '../../../../actions/siteadmin/modalActions';
import AddSubMenuModal from '../SubMenu/AddSubMenuModal';
import CurrencyConverter from '../../../CurrencyConverter';

import history from '../../../../history';
import { api, itemImageUploadDir } from '../../../../config'
import ConfirmationPopup from '../../../Common/ConfirmationPopup';
import DefaultImage from '../../../../../public/RestaurantIcon/defaultFood.svg';
import debounce from '../../../../helpers/debounce';

class ItemList extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      currentPage: 1,
      searchList: '',
      load: false
    };

    this.paginationData = this.paginationData.bind(this);
    this.handleKeywordSearch = debounce(this.handleKeywordSearch.bind(this), 250);
    this.handleStatus = this.handleStatus.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.calculateOverallAmount = this.calculateOverallAmount.bind(this);
    this.isValueDefined = this.isValueDefined.bind(this);
  }

  isValueDefined(value) {
    if (value && value !== undefined && value !== null && String(value) !== '') {
      return true
    }

    return false;
  }

  handleKeywordSearch(searchList) { // Keyword search
    const { itemDetails: { refetch }, menuId } = this.props;

    let variables = {
      currentPage: 1,
      searchList,
      menuId
    };

    this.setState({ currentPage: 1, searchList })
    refetch(variables);
  }

  handleSearchClick(searchList) {
    const { itemDetails: { refetch }, menuId } = this.props
    let variables = {
      currentPage: 1,
      searchList: searchList,
      menuId: menuId
    }
    this.setState({ currentPage: 1 })
    refetch(variables)
  }

  handleSearchChange(e) {
    let self = this
    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout)
    }
    self.setState({
      searchList: e.target.value,
      typing: false,
      typingTimeout: setTimeout(function () {
        self.handleSearchClick(self.state.searchList)
      }, 450)
    })
  }

  async handleDelete(id, currentPage, section) {
    const { deleteItem, itemDetails: { refetch }, menuId, deleteSubMenu, closeModal } = this.props;
    let variables = { currentPage, menuId };

    if (section == 'subMenu') {
      await deleteSubMenu(id, currentPage, menuId)
      await closeModal('subMenuDeleteModal')
      refetch(variables)
    } else {
      await deleteItem(id, currentPage, menuId);
      refetch(variables);
    }
  };

  paginationData(currentPage) {
    const { itemDetails: { refetch }, menuId } = this.props;
    let variables = { currentPage, menuId };

    this.setState({ currentPage });
    refetch(variables);
  };

  async handleStatus(id, status, currentPage, section) {
    const { updateItemStatus, itemDetails: { refetch }, menuId, updateSubMenuStatus } = this.props;
    let variables = { currentPage, menuId };


    if (section == 'subMenu') {
      await updateSubMenuStatus(id, status, currentPage, menuId)
      refetch(variables)
    } else {
      await updateItemStatus(id, status, currentPage, menuId);
      refetch(variables);
    }
  };

  calculateOverallAmount(amount, tax) {
    let taxValue = 0
    if (amount && Number(amount) > 0 && tax && Number(tax) > 0) {
      taxValue = Number(amount) * (Number(tax) / 100);
      return amount + taxValue;
    } else {
      return amount;
    }
  }


  componentDidMount() {
    this.setState({
      load: true
    });
  }

  componentDidUpdate(prevProps) {
    const { locale } = this.props.intl;
    const { locale: prevLocale } = prevProps.intl;
    if (locale !== prevLocale) {
      this.setState({
        load: false
      });
      clearTimeout(this.loadSync);
      this.loadSync = null;
      this.loadSync = setTimeout(() => {
        this.setState({
          load: true
        })
      }, 450);
    }
  }

  render() {
    const { itemDetails, openSubMenuModal, menuId, editItem, editSubMenu, modalData } = this.props;
    const { closeModal, openModal, subMenuDeleteModal, profile } = this.props;
    const { formatMessage } = this.props.intl;
    const { currentPage } = this.state;
    const { load } = this.state;

    return (
      <div className={'mainContainer'}>
        <div>
          <ConfirmationPopup
            modalStatus={subMenuDeleteModal}
            title={formatMessage(messages.deleteMenuTitle)}
            body={formatMessage(messages.deleteConfirmation)}
            closeModal={() => closeModal('subMenuDeleteModal')}
            popupButtonLeftName={formatMessage(messages.cancelButton)}
            popupButtonRightName={formatMessage(messages.deleteAction)}
            popupButtonLeftFunction={() => closeModal('subMenuDeleteModal')}
            popupButtonRightFunction={() => this.handleDelete(modalData.id, modalData.currentPage, 'subMenu')}
          />
        </div>
        <Container fluid>
          <AddSubMenuModal />
          <Row>
            <Col lg={12} md={12} sm={12} xs={12}>
              <h1 className={rs.restaurantTitleText}>
                {
                  itemDetails && itemDetails.getAllSubMenu && itemDetails.getAllSubMenu.menuName
                }
              </h1>
            </Col>
            <Col lg={12} md={12} sm={12} xs={12}>
              <div className={cx(rs.searchInputRestaurant)}>
                <FormControl type='text' placeholder={formatMessage(messages.search)}
                  onChange={(e) => this.handleKeywordSearch(e.target && e.target.value)} className={cx(rs.formControlInputRestaurant, rs.searchInputWidth)} />
              </div>
              <div className={cx(s.displayInlineBlock, rs.searchTopBtn, 'textAlignLeftRTL')}>
                <Button className={cx(rs.button, rs.btnPrimary, rs.textOverFlow)} onClick={() => openSubMenuModal(menuId)}>
                  <FormattedMessage {...messages.addSubMenu} />
                </Button>
              </div>
            </Col>
          </Row>
          {
            itemDetails && itemDetails.getAllSubMenu && itemDetails.getAllSubMenu.results && itemDetails.getAllSubMenu.results.length > 0 && itemDetails.getAllSubMenu.results.map((item, index) => {
              return (
                <Row key={`submenu_${index}`}>
                  <Col xs={12} lg={12} md={12} sm={12}>
                    <div className={rs.menuItemGrid}>
                      <div className={cx(rs.menuFirstSection, s.marginBottomlistItem, rs.subMenuGridWidth, 'topBtnScetionMbRTL')}>
                        <div className={cx(rs.alignLeft, rs.tabSection, 'textAlignRightRTL')}>
                          <p className={rs.idTitle}>
                            {item.name}
                          </p>
                        </div>
                        <div className={'restaurantActiveSelect'}>
                          <select value={item.isEnable} onChange={(e) => { this.handleStatus(item.id, e.target.value, currentPage, 'subMenu') }} className={cx(rs.activeSelect, rs.restaurantSelectInput)}>
                            <option value={true}>{formatMessage(messages.active)}</option>
                            <option value={false}>{formatMessage(messages.inactive)}</option>
                          </select>
                        </div>
                        <div>
                          <Button className={cx(rs.deleteBtn, s.editBtn, s.IconLeft, rs.textOverFlow)} onClick={() => editSubMenu(item.id)}>
                            <img src={EditIcon} className={cx(s.iconsWidth, 'iconsWidthRTL')} />
                            <span className={rs.vtrMiddle}>{formatMessage(messages.editItem)}</span>
                          </Button>
                        </div>
                        <div>
                          <Button className={cx(rs.deleteBtn, s.editBtn, s.IconLeft, rs.textOverFlow)} onClick={() => openModal('subMenuDeleteModal', { id: item.id, modalName: 'subMenuDeleteModal', currentPage })}>
                            <img src={TrashIcon} className={cx(s.iconsWidth, 'trashIconRTL')} />
                            <span className={rs.vtrMiddle}>{formatMessage(messages.deleteAction)}</span>
                          </Button>

                        </div>
                        <div className={cx(s.IconRight, 'textAlignLeftRTL', 'mobileTextLeftRTL')}>
                          <Link to={"/restaurant/menu/" + item.menuId + "/item/" + item.id + "/add"} className={cx(rs.button, rs.btnPrimary, s.displayInlineBlock)}>{formatMessage(messages.addItem)}</Link>
                        </div>
                      </div>
                      {item && item.item && item.item.length == '0' && (
                        <div className={cx(rs.spaceTop5, rs.space2, rs.alignCenter, rs.activeDays)}>
                          <p colspan="12"><FormattedMessage {...messages.noFoodItem} />.</p>
                        </div>
                      )}
                      {
                        item && item.item && item.item.map((foodItem, index) => {
                          let itemLength = item && item.item && item.item.length - 1;
                          let foodPrice = this.calculateOverallAmount(foodItem.price, foodItem.tax);
                          return (
                            <Col key={`foodItem_${index}`} lg={12} md={12} sm={12} xs={12} className={cx(rs.noPadding, rs.spaceTop3)}>
                              <div className={cx(rs.menuFirstSection, s.noborderImg, s.itemBottomBorder, rs.submenuGrid, rs.subMenuGridWidth, 'topBtnScetionMbRTL')}>
                                {/* {
                                  !load && <div>
                                    <Loader type="text" />
                                  </div>
                                } */}
                                {
                                 
                                  <div className={cx(rs.alignLeft, rs.tabSection, 'menuFirstSectionRTL', 'textAlignRightRTL')}>
                                    {foodItem.image ?
                                      <div
                                        className={cx(s.itemBgImg, 'itemBgImgRTL', (itemLength === index ? '' : s.itemBgImgBorder), (!foodItem.isEnable ? s.inactive : ''))}
                                        style={{ backgroundImage: `url(${api.apiEndpoint + itemImageUploadDir + foodItem.image})` }}
                                      />
                                      :
                                      <div
                                        className={cx(s.itemBgImg, 'itemBgImgRTL', (itemLength === index ? '' : s.itemBgImgBorder), (!foodItem.isEnable ? s.inactive : ''))}
                                        style={{ backgroundImage: `url(${DefaultImage})` }}
                                      />
                                    }
                                    <p key={`foodItem_p_${index}`} className={cx(s.activeDaysText, s.itemListContent, 'itemListContentRTL')}>
                                      <span className={s.foodNameSection}>{foodItem.itemName}</span>
                                      <span className={s.priceColor}>
                                        <CurrencyConverter from={profile.preferredCurrency} toCurrency={profile.preferredCurrency} amount={foodPrice} />
                                      </span>
                                      {
                                        foodItem && this.isValueDefined(foodItem.tax) && <span className={s.subText}>(<FormattedMessage {...messages.includesTax} />)</span>
                                      }
                                    </p>
                                  </div>
                                }
                                <div className={cx('restaurantActiveSelect')}>
                                  <select value={foodItem.isEnable} onChange={(e) => { this.handleStatus(foodItem.id, e.target.value, currentPage) }} className={cx(rs.activeSelect, rs.restaurantSelectInput)}>
                                    <option value={true}>{formatMessage(messages.active)}</option>
                                    <option value={false}>{formatMessage(messages.inactive)}</option>
                                  </select>
                                </div>
                                <div>

                                  <a href={"/restaurant/menu/" + item.menuId + "/item/" + item.id + "/edit/" + foodItem.id} className={cx(rs.linkColor, s.displayInlineBlock)}>
                                    <img src={EditIcon} className={cx(s.iconsWidth, 'iconsWidthRTL')} />
                                    <span className={cx(rs.vtrMiddle, s.editSection)}>{formatMessage(messages.editItem)}</span>
                                  </a>
                                </div>
                                <div>
                                  <Button className={cx(rs.deleteBtn, s.editBtn, s.IconLeft, rs.textOverFlow)} onClick={() => this.handleDelete(foodItem.id, currentPage)}>
                                    <img src={TrashIcon} className={cx(s.iconsWidth, 'iconsWidthRTL')} />
                                    <span className={rs.vtrMiddle}>{formatMessage(messages.deleteAction)}</span>
                                  </Button>
                                </div>
                                <div>
                                  <p className={rs.noMargin}>
                                    <span><img src={foodItem && foodItem.itemType == "1" ? VegIcon : NonVegIcon} className={s.activeImg} alt='VegImage' /></span>
                                    <span className={rs.vtrMiddle}>
                                      {foodItem.itemType == "1" ? formatMessage(messages.itemType1) : formatMessage(messages.itemType2)}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </Col>
                          )
                        })
                      }
                    </div>
                  </Col>
                </Row>
              )
            })
          }
          {
            itemDetails && itemDetails.getAllSubMenu && itemDetails.getAllSubMenu.results.length == 0 && (
              <span className={rs.notFoundText}><FormattedMessage {...messages.noSubMenu} />.</span>
            )
          }
          <Row>
            <Col xs={12} lg={12} md={12} sm={12} className={cx(rs.spaceTop5, rs.alignRightText, 'textAlignLeftRTL')}>
              <div className={cx(s.paddingTop2, s.displayInlineBlock)}>
                <Button className={cx(rs.button, rs.btnPrimaryBorder)} onClick={() => history.push('/restaurant/menu')}>
                  <FormattedMessage {...messages.back} />
                </Button>
              </div>
            </Col>
          </Row>
          {
            itemDetails && itemDetails.getAllSubMenu && itemDetails.getAllSubMenu.results && itemDetails.getAllSubMenu.results.length > 0
            && <div className={cx(s.space5, s.spaceTop5, 'restaurant')}>
              <CustomPagination
                total={itemDetails.getAllSubMenu.count}
                currentPage={currentPage}
                defaultCurrent={1}
                defaultPageSize={10}
                change={this.paginationData}
                paginationLabel={formatMessage(messages.subMenus)}
              />
            </div>
          }
        </Container>
      </div>
    );
  }
}

const mapDispatch = {
  deleteItem,
  updateItemStatus,
  editItem,
  openSubMenuModal,
  updateSubMenuStatus,
  deleteSubMenu,
  editSubMenu,
  openModal,
  closeModal
};
const mapState = (state) => ({
  subMenuDeleteModal: state.modalStatus.subMenuDeleteModal,
  modalData: state.modalStatus.data && state.modalStatus.data[0],
  profile: state.account.data && state.account.data.profile,
});

export default injectIntl(withStyles(s, rs)(connect(mapState, mapDispatch)(ItemList)));